// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { IAddressInfoDto } from './IAddressInfoDto';
import {
    IAddressInfoDtoFromJSON,
    IAddressInfoDtoFromJSONTyped,
    IAddressInfoDtoToJSON,
    IAddressInfoDtoToJSONTyped,
} from './IAddressInfoDto';

/**
 * 
 * @export
 * @interface ILinkedEmployeeInfoDto
 */
export interface ILinkedEmployeeInfoDto {
    /**
     * 
     * @type {number}
     * @memberof ILinkedEmployeeInfoDto
     */
    employee_id?: number;
    /**
     * 
     * @type {number}
     * @memberof ILinkedEmployeeInfoDto
     */
    person_id?: number;
    /**
     * 
     * @type {string}
     * @memberof ILinkedEmployeeInfoDto
     */
    first_name?: string;
    /**
     * 
     * @type {string}
     * @memberof ILinkedEmployeeInfoDto
     */
    last_name?: string;
    /**
     * 
     * @type {Date}
     * @memberof ILinkedEmployeeInfoDto
     */
    date_of_birth?: Date;
    /**
     * 
     * @type {string}
     * @memberof ILinkedEmployeeInfoDto
     */
    ssn?: string;
    /**
     * 
     * @type {string}
     * @memberof ILinkedEmployeeInfoDto
     */
    employer_employee_id?: string;
    /**
     * 
     * @type {string}
     * @memberof ILinkedEmployeeInfoDto
     */
    partner_employee_id?: string;
    /**
     * 
     * @type {string}
     * @memberof ILinkedEmployeeInfoDto
     */
    employment_status?: ILinkedEmployeeInfoDtoEmploymentStatusEnum;
    /**
     * 
     * @type {string}
     * @memberof ILinkedEmployeeInfoDto
     */
    employer_name?: string;
    /**
     * 
     * @type {IAddressInfoDto}
     * @memberof ILinkedEmployeeInfoDto
     */
    address?: IAddressInfoDto;
    /**
     * 
     * @type {boolean}
     * @memberof ILinkedEmployeeInfoDto
     */
    is_primary_linked_account?: boolean;
    /**
     * 
     * @type {Array<ILinkedEmployeeInfoDto>}
     * @memberof ILinkedEmployeeInfoDto
     */
    linked_employees?: Array<ILinkedEmployeeInfoDto>;
}

/**
* @export
* @enum {string}
*/
export enum ILinkedEmployeeInfoDtoEmploymentStatusEnum {
    A = 'A',
    T = 'T',
    L = 'L',
    R = 'R',
    F = 'F',
    C = 'C'
}


/**
 * Check if a given object implements the ILinkedEmployeeInfoDto interface.
 */
export function instanceOfILinkedEmployeeInfoDto(value: object): value is ILinkedEmployeeInfoDto {
    return true;
}

export function ILinkedEmployeeInfoDtoFromJSON(json: any): ILinkedEmployeeInfoDto {
    return ILinkedEmployeeInfoDtoFromJSONTyped(json, false);
}

export function ILinkedEmployeeInfoDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): ILinkedEmployeeInfoDto {
    if (json == null) {
        return json;
    }
    return {
        
        'employee_id': json['employee_id'] == null ? undefined : json['employee_id'],
        'person_id': json['person_id'] == null ? undefined : json['person_id'],
        'first_name': json['first_name'] == null ? undefined : json['first_name'],
        'last_name': json['last_name'] == null ? undefined : json['last_name'],
        'date_of_birth': json['date_of_birth'] == null ? undefined : (new Date(json['date_of_birth'])),
        'ssn': json['ssn'] == null ? undefined : json['ssn'],
        'employer_employee_id': json['employer_employee_id'] == null ? undefined : json['employer_employee_id'],
        'partner_employee_id': json['partner_employee_id'] == null ? undefined : json['partner_employee_id'],
        'employment_status': json['employment_status'] == null ? undefined : json['employment_status'],
        'employer_name': json['employer_name'] == null ? undefined : json['employer_name'],
        'address': json['address'] == null ? undefined : IAddressInfoDtoFromJSON(json['address']),
        'is_primary_linked_account': json['is_primary_linked_account'] == null ? undefined : json['is_primary_linked_account'],
        'linked_employees': json['linked_employees'] == null ? undefined : ((json['linked_employees'] as Array<any>).map(ILinkedEmployeeInfoDtoFromJSON)),
    };
}

export function ILinkedEmployeeInfoDtoToJSON(json: any): ILinkedEmployeeInfoDto {
    return ILinkedEmployeeInfoDtoToJSONTyped(json, false);
}

export function ILinkedEmployeeInfoDtoToJSONTyped(value?: ILinkedEmployeeInfoDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'employee_id': value['employee_id'],
        'person_id': value['person_id'],
        'first_name': value['first_name'],
        'last_name': value['last_name'],
        'date_of_birth': value['date_of_birth'] == null ? undefined : ((value['date_of_birth']).toISOString().substring(0,10)),
        'ssn': value['ssn'],
        'employer_employee_id': value['employer_employee_id'],
        'partner_employee_id': value['partner_employee_id'],
        'employment_status': value['employment_status'],
        'employer_name': value['employer_name'],
        'address': IAddressInfoDtoToJSON(value['address']),
        'is_primary_linked_account': value['is_primary_linked_account'],
        'linked_employees': value['linked_employees'] == null ? undefined : ((value['linked_employees'] as Array<any>).map(ILinkedEmployeeInfoDtoToJSON)),
    };
}

